import { Component, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MatDialog, MatDialogConfig, MatDialogRef } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { CellImageFormatterComponent } from '../cell-image-formatter/cell-image-formatter.component';
import { ActivatedRoute, Router } from '@angular/router';
import { TestigosService } from '../../services/testigos.service';
import { CellDateFormatterComponent } from '../cell-date-formatter/cell-date-formatter.component';
import { debounceTime } from 'rxjs/operators';
import { TestigosEditComponent } from '../testigos-edit/testigos-edit.component'
import { Location } from '@angular/common';

@Component({
  selector: 'app-testigos',
  templateUrl: './testigos.component.html',
  styleUrls: ['./testigos.component.scss']
})
export class TestigosComponent implements OnInit {

  public translate: TranslateService;
  public columnDefs: any[];
  private gridApi;
  isModal: boolean;
  dialogConfig: MatDialogConfig;
  public row: number = null;

  public defaultColDef = {
    // set every column width
    width: 100,
    // make every column editable
    // make every column use 'text' filter by default
    filter: 'agTextColumnFilter'
  };

  public rowData: any;
  searchTerm: FormControl = new FormControl();

  createColumnDef() {
    const columnDefs = [
      {
        headerName: '', field: 'id', suppressFilter: true, suppressSorting: true,
        template: `<a data-action-type="remove"><i data-action-type="remove" class="fa fa-remove text-danger"></i></a>`,
        minWidth: 35,
        width: 35
      },
      {
        headerName: '', field: 'id', cellClass: 'grid-opendialog',
        template: `<i class="fa fa-edit text-info"></i>`,
        minWidth: 40,
        width: 40
      },
      //{ headerName: 'ID', field: 'id', minWidth: 150 },
      { headerName: 'Tipo de propiedad', field: 'tipoPropiedad', minWidth: 150 },
      {
        headerName: 'Fecha de analisis', field: 'fechaAnalisis',
        cellRendererFramework: CellDateFormatterComponent, minWidth: 150
      },
      { headerName: 'Valor global', field: 'valorGlobal', minWidth: 150 },
      { headerName: 'Tipología', field: 'tipologia', minWidth: 50 },
      { headerName: 'Valor unitario', field: 'valorUnitario', minWidth: 150 },
      { headerName: 'Superficie total', field: 'supTotal', minWidth: 150 },
      { headerName: 'Construcción', field: 'anioConstr', minWidth: 150 },
      { headerName: 'Direccion', field: 'direccion', minWidth: 150 },
      { headerName: 'Telf', field: 'tlfContacto', minWidth: 100 }
    ];

    return columnDefs;
  }

  constructor(private _TestigosService: TestigosService, private _router: Router, private _route: ActivatedRoute,
    private _dialog: MatDialog, _translateService: TranslateService, public dialogRef: MatDialogRef<TestigosComponent>,private _location: Location) {
    this.translate = _translateService;
    this.columnDefs = this.createColumnDef();
    
    this.dialogConfig = new MatDialogConfig();
    this.dialogConfig.disableClose = false;
    this.dialogConfig.autoFocus = true;
    this.dialogConfig.closeOnNavigation = true;
    this.dialogConfig.maxWidth = '700px'
    this.dialogConfig.disableClose = true;
  }

  ngOnInit() {
    this.getData();
    this.searchTerm.valueChanges.pipe(debounceTime(400)).subscribe(data => {
      this.getData();
    });
  }

  onGridReady(params) {
    this.gridApi = params.api;
    this.gridApi.sizeColumnsToFit();
  }

  private getData() {
    let svc;
    if (this.searchTerm.value != null) {
      svc = this._TestigosService.getTestigosFiltered(this.searchTerm.value);
    } else {
      svc = this._TestigosService.getTestigos();
    }
    svc.subscribe(data => {
      this.rowData = data;
    }
      , err => console.error('Error al recuperar datos de clientes'));
  }

  public newItem() {
    const ref = this._dialog.open(TestigosEditComponent, this.dialogConfig);
    ref.componentInstance.isModal = true;
    ref.afterClosed().subscribe(result => {
      this.getData();
    });
  }

  public onCellClickedEvent($event) {
    if ($event.event.target !== undefined) {
      let data = $event.data;
      let actionType = $event.event.target.getAttribute("data-action-type");

      switch (actionType) {
        case "remove":
          return this.onActionRemoveClick(data);
      }
    }

    if ($event.colDef.cellClass !== undefined && $event.colDef.cellClass.indexOf('grid-opendialog') >= 0) {
      const dlgRef = this._dialog.open(TestigosEditComponent, this.dialogConfig);
      dlgRef.componentInstance.id = $event.data.id;
      dlgRef.componentInstance.isModal = true;
      dlgRef.afterClosed().subscribe(result => {
        this.getData();
      });
    }

    this.getSelectedItem();
  }

  onActionRemoveClick(data: any) {
    var ans = confirm("Quieres eliminar el registro con Id: " + data.id);
    if (ans) {
      this._TestigosService.deleteTestigo(data.id).subscribe((data: any) => {
        if (data.estado == "Error") {
          alert("Este cliente está asociado a alguna tasación, por lo que no se puede borrar. Si lo desea puede marcarlo como inactivo.");
        }
        this.getData();
      });
    }
  }

  closeDialog() {
    this.dialogRef.close(this.row);
  }

  cancel() {
    if (!this.isModal) {
      this._location.back();
    } else {
      this.dialogRef.close(null);
    }
  }

  seleccionar(){
    if (!this.isModal) {
      this._location.back();
    } else {
      this.dialogRef.close(this.row);
    }
  }

  getSelectedItem() {
    if (this.gridApi.getSelectedNodes().length === 1) {
      const selectedRow = this.gridApi.getSelectedNodes()[0];
      const rowid = selectedRow.data.id;
      console.log(rowid);
      this.row = rowid;
      return rowid;

    } else {
      this.row = null;
      return null;
    }
  }

}
